import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { FieldCheckbox } from "./FieldCheckbox"
import { FieldText } from "./FieldText"

interface IFieldImpressionCountProps {
  inputValue: number
  checkboxValue: boolean
  fieldImpressionName?: string
  fieldCheckboxName?: string
  error?: string
  sx?: any
}

const FIELD_IMPRESSIONS_NAME: string = "main.max_views"
const FIELD_CHECKBOX_NAME: string = "main.unlimitedImpressions"

export const FieldImpressionCount = React.memo(
  ({ inputValue, checkboxValue, fieldImpressionName, fieldCheckboxName, error, sx }: IFieldImpressionCountProps) => {
    const impressionFieldName = fieldImpressionName ? fieldImpressionName : FIELD_IMPRESSIONS_NAME
    const checkboxFieldName = fieldCheckboxName ? fieldCheckboxName : FIELD_CHECKBOX_NAME
    return (
      <FlexBox wrap sx={{ "gap": ".5rem", "& input.Mui-disabled": { opacity: 0 }, ...sx }}>
        <FieldText
          fieldName={impressionFieldName}
          isNumber
          label={translate("label.campaign.impressions")}
          value={inputValue}
          disabled={checkboxValue}
          error={error}
          clearable
          sx={{ width: "100%" }}
        />
        <Typography color="textSecondary" sx={{ fontSize: ".8rem" }}>
          {translate("label.or")}
        </Typography>
        <FieldCheckbox
          fieldName={checkboxFieldName}
          toTouchFieldName={impressionFieldName}
          label={translate("label.impressions.unlimited")}
          value={checkboxValue}
        />
      </FlexBox>
    )
  }
)
